import React from 'react';
import Box from '@mui/system/Box';
import { useStacklineTheme } from '@stackline/ui';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Route, Switch } from 'react-router-dom';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ContentSettingsInnerPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Settings/ContentSettingsInnerPage';
import ContentCreditsInnerPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Credits/ContentCreditsInnerPage';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useLocation } from 'src/utils/Hooks/typedHooks';

export enum ContentTab {
  Profiles = 'profiles',
  Settings = 'settings',
  Credits = 'credits'
}

export enum ContentTabsDisplayName {
  Profiles = 'Profiles',
  Settings = 'Master Content',
  Credits = 'Content Credits'
}

export enum ContentTabsPath {
  Settings = '/account/content/settings',
  Credits = '/account/content/credits'
}

const getCurrentTabFromPathname = (pathname: string): ContentTab => {
  if (pathname.includes(ContentTabsPath.Credits)) {
    return ContentTab.Credits;
  }
  return ContentTab.Settings;
};

export const ContentNavigationTabs = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const location = useLocation();
  const tab = getCurrentTabFromPathname(location.pathname);

  return (
    <GenericNavigationTabs
      tab={tab}
      tabs={[
        {
          label: ContentTabsDisplayName.Settings,
          onClick: () => {
            beaconNavigator.setPathname(ContentTabsPath.Settings);
            beaconNavigator.go();
          },
          value: ContentTab.Settings
        },
        {
          label: ContentTabsDisplayName.Credits,
          onClick: () => {
            beaconNavigator.setPathname(ContentTabsPath.Credits);
            beaconNavigator.go();
          },
          value: ContentTab.Credits
        }
      ]}
    />
  );
};

const ContentTopNav = () => {
  return (
    <Flex justifyContent="space-between" flexDirection="row" alignItems="center">
      <Text variant="h2">Content</Text>
    </Flex>
  );
};

const SettingsContentPageLayout = () => {
  const theme = useStacklineTheme();

  return (
    <Box>
      <ContentTopNav />
      <Box marginBottom={theme.spacing.lg}>
        <ContentNavigationTabs />
        <BasePageContainer>
          <Switch>
            <Route exact path={ContentTabsPath.Settings} component={ContentSettingsInnerPage} />
            <Route exact path={ContentTabsPath.Credits} component={ContentCreditsInnerPage} />
          </Switch>
        </BasePageContainer>
      </Box>
    </Box>
  );
};

export default SettingsContentPageLayout;
